import * as users from "./action-types/action-types-users";
import * as groups from "./action-types/action-types-groups";

export {users, groups};

export const NAMESPACE = 'BASE_VIEWER/';
export const SET_BASE_VIEWER_TYPE = NAMESPACE + 'SET_BASE_VIEWER_TYPE';
